// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"26":"b74c674a","95":"b74c674a","348":"9a2d1b4a","477":"8d2bde22","481":"1d3a9455","668":"b74c674a","763":"829ec3fa","769":"b74c674a","878":"64812511"}[chunkId] + ".chunk.css";
};